import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 239 188"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "#27C9F4",
      "clip-path": "url(#i-1624335230__a)",
      opacity: ".1"
    }, [
      _createElementVNode("path", { d: "M62.17 107.146c-11.266 0-21.637-3.864-30.017-10.317.829 26.911 20.996 53.822 60.81 80.747l-5.907 9.455C29.373 150.076.532 109.531.532 65.395c0-20.265 5.346-36.16 16.065-47.629C27.302 6.27 40.854.53 57.239.53c16.398 0 29.603 4.617 39.666 13.853 10.051 9.222 15.076 20.389 15.076 33.447 0 .15-.027.26-.027.411.307 2.316.521 4.659.521 7.07 0 28.625-22.533 51.837-50.305 51.836ZM224.806 19.507c.655.78 1.443 1.52 2.031 2.33 7.405 9.029 11.908 20.69 11.908 33.474 0 28.624-22.519 51.849-50.291 51.849-12.723 0-24.297-4.905-33.158-12.935 0 .316-.053.59-.053.919 0 27.473 20.314 54.973 60.97 82.446l-5.908 9.441c-57.695-36.955-86.536-77.5-86.536-121.649 0-20.266 5.345-36.16 16.064-47.63C150.538 6.258 164.09.516 180.475.516s29.616 4.618 39.667 13.867c1.416 1.288 2.526 2.74 3.742 4.124.321.316.601.658.922 1Z" })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "i-1624335230__a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M.532 187.086h238.213V.46H.532z"
        })
      ])
    ], -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "quotation"}) } }